module.exports = __webpack_public_path__ + "1df8d7907fa38ce35a45ae7b9f0a2c21.png";